import { render, staticRenderFns } from "./RegSuccess.vue?vue&type=template&id=35abaa53&"
import script from "./RegSuccess.vue?vue&type=script&lang=js&"
export * from "./RegSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports